import ShopAll from './features/shop/views/ShopAllPage';
import ProductViewPage from './features/shop/views/ProductViewPage';
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  Link,
} from "react-router-dom";

export const routes = [
  {
    name: 'products',
    path: '/products',
    component: ShopAll
  },
  // {
  //   name: 'product view',
  //   path: '/products/:productId/:brandName',
  //   component: ProductViewPage
  // },
  {
    name: 'category products',
    path: '/categories/:categoryName',
    component: ShopAll
  }
]
export const router = createBrowserRouter(
  routes.map(
    each =>({
      path: each.path,
      element: (
      <each.component />
      ),
    })
  )
);



